//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import ProductModel from '@/models/Warehouse/WhProduct'
import fields from './fields'

//
export default {
    name: 'dispatch-requests-batch-create',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                loading: this.formBusy,
                fields,
            }
        },
    },
    data() {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        fetch() {
            return ProductModel
                .append('branch_offices', 'repacking_children', 'sale_prices,stocks')
                .include('wh_item', 'wh_subfamily')
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'product' })
        },

        /**
         *
         */
        repacking(model) {
            model
                .repacking()
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        reset() {
            this.fetch((this.formBusy = true))
        },

        /**
         *
         */
        setFormData(model) {
            this.formBusy = false
            this.formData = model.clone().reset()
        },

        /**
         *
         */
        showError(error) {
            console.log({ error })
            this.showSnackbar(
                'error',
                'Error.',
                Translator(ProductModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Productos reenvasados asignados.'
            )
        },

        /**
         *
         */
        submit(model) {
            this.$refs.form.setWait(true).then(this.repacking)
        },
    },
    beforeMount() {
        this.setTitle('Asignar productos reenvasados')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_REPACKING')) ctx.$router.push('/')
        })
    },
}
